const RETURN_URL_KEY = "returnUrl"

export const encodeReturnUrl = (path) => {
  if (!path || path === "/login") return ""
  return btoa(encodeURIComponent(path))
}

export const decodeReturnUrl = (value) => {
  if (!value) return ""
  try {
    const decoded = decodeURIComponent(atob(value))
    if (!isSafeReturnUrl(decoded)) return ""
    return decoded
  } catch (_) {
    try {
      const decoded = atob(value)
      return isSafeReturnUrl(decoded) ? decoded : ""
    } catch (__) {
      return ""
    }
  }
}

export const isSafeReturnUrl = (path) => {
  return (
    typeof path === "string" &&
    path.indexOf("/") === 0 &&
    path.indexOf("//") !== 0 &&
    path.indexOf("/login") !== 0
  )
}

export const saveReturnUrl = (path) => {
  if (isSafeReturnUrl(path)) {
    localStorage.setItem(RETURN_URL_KEY, path)
  }
}

export const popReturnUrl = () => {
  const path = localStorage.getItem(RETURN_URL_KEY)
  localStorage.removeItem(RETURN_URL_KEY)
  return isSafeReturnUrl(path) ? path : ""
}

